import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  Sparkles,
  ArrowLeft,
  FileSpreadsheet,
  Handshake,
  LayoutDashboard,
  BarChart3,
  Users,
  Map,
  MessageSquare,
  Trash2,
  Briefcase,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";

const navItems = [
  { id: "overview", label: "Overview", path: "/admin", icon: LayoutDashboard },
  {
    id: "benchmarks",
    label: "Benchmarks",
    path: "/admin/benchmarks",
    icon: BarChart3,
  },
  { id: "users", label: "Users", path: "/admin/users", icon: Users },
  { id: "deals", label: "Deals", path: "/admin/deals", icon: Briefcase },
  {
    id: "templates",
    label: "Templates",
    path: "/admin/templates",
    icon: FileSpreadsheet,
  },
  {
    id: "partners",
    label: "Partners",
    path: "/admin/partners",
    icon: Handshake,
  },
  { id: "roadmap", label: "Roadmap", path: "/admin/roadmap", icon: Map },
  {
    id: "consulting",
    label: "Consulting",
    path: "/admin/consulting",
    icon: MessageSquare,
  },
  {
    id: "deletion-requests",
    label: "Deletion Requests",
    path: "/admin/deletion-requests",
    icon: Trash2,
  },
  {
    id: "payroll-сonfig",
    label: "Payroll Config",
    path: "/admin/payroll-config",
    icon: Users,
  },
  {
    id: "excel-template",
    label: "Excel Template",
    path: "/admin/excel-template",
    icon: FileSpreadsheet,
  },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    const matchingTab = [...navItems]
      .sort((a, b) => b.path.length - a.path.length)
      .find((tab) => location.pathname.startsWith(tab.path));

    if (matchingTab) {
      return matchingTab.id;
    }

    if (location.pathname === "/admin") {
      return navItems[0].id;
    }

    return navItems[0].id;
  };

  const activeTab = getActiveTab();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between">
          <div className="flex items-center gap-2 ml-8">
            <Sparkles className="h-6 w-6 text-primary-blue" />
            <span className="text-xl font-bold tracking-tight">
              Hotel Foundry
            </span>
            <span className="ml-2 px-2 py-0.5 text-xs font-medium bg-destructive/10 text-destructive rounded">
              Admin
            </span>
          </div>
          <Button variant="ghost" onClick={() => navigate("/dashboard")}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </div>
      </header>

      <div className="flex">
        <aside className="w-72 border-r border-border/40 min-h-[calc(100vh-4rem)] p-6">
          <nav className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeTab === item.id;

              return (
                <button
                  key={item.id}
                  onClick={() => navigate(item.path)}
                  className={cn(
                    "w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-base font-medium transition-all duration-200",
                    isActive
                      ? "text-[#1d4fd7] bg-[#1d4fd7]/10 font-semibold shadow-sm"
                      : "text-muted-foreground hover:bg-muted/80 hover:text-foreground hover:shadow-sm",
                  )}
                >
                  <Icon className="h-5 w-5" />
                  {item.label}
                </button>
              );
            })}
          </nav>
        </aside>

        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
